import { useRouter } from 'next/router';
import { useEffect } from 'react';

const STORE_KEY = 'storeId';

export const usePos365StoreCode = () => {
  const router = useRouter();

  const setPos365StoreCode = () => {
    const storeId = router.query[STORE_KEY] as string;
    if (typeof sessionStorage !== 'undefined' && storeId)
      sessionStorage.setItem(STORE_KEY, storeId);
  };

  const getPos365StoreCode = () => {
    if (typeof sessionStorage !== 'undefined')
      return sessionStorage.getItem(STORE_KEY);
  };

  useEffect(() => {
    setPos365StoreCode();
    // eslint-disable-next-line
  }, [JSON.stringify(router.query)]);

  return {
    pos365StoreCode: getPos365StoreCode(),
  };
};
